import Alert from 'components/atoms/Alert/Alert';
import RegistrationCard from 'components/atoms/RegistrationCard/RegistrationCard';
import SecondFactorCode from 'components/atoms/TextInput/SecondFactorCode';
import Form from 'components/molecules/Form/Form';
import { useConfirm2fa } from 'components/templates/AuthenticationProvider/AuthenticationProvider';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import classes from './RegistrationForm.module.scss';

type Props = {
  sessionId: string | undefined;
  username: string | undefined;
};

export default function SecondFactorStep({ sessionId, username }: Props) {
  const confirm2fa = useConfirm2fa();
  const router = useRouter();
  const [localError, setLocalError] = useState<string | null>(null);

  const [allOtpFilled, setAllOtpFilled] = React.useState(false);

  function handleSubmit(formData: FormData) {
    if (formData.has('2fa_code') && sessionId) {
      confirm2fa(sessionId, formData.get('2fa_code')?.toString() ?? '')
        .then(() => {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'CompleteRegistration',
          });
        })
        .then(() => router.push('/register-success'))
        .catch((e) => {
          if (e instanceof Error) {
            setLocalError(e.message);
          } else {
            setLocalError('An error occurred');
          }
        });
    }
  }

  return (
    <RegistrationCard title="" narrowContainer stepTitleClassName={classes.titleCenter}>
      {localError && (
        <Alert
          type={'error'}
          title={'An error occurred'}
          subtitle={localError}
          onClose={() => setLocalError(null)}
        />
      )}

      <Form
        submitName="Sign Up"
        submitButtonType="primary"
        submitButtonClassName={classes.nextButton}
        onSubmit={handleSubmit}
        className={classes.formOverrides}
        submitDisabled={!allOtpFilled}
      >
        <SecondFactorCode
          username={username}
          returnHref="/registration"
          actionText="Re-register account"
          initialText="Re-register in "
          onAllInputsFilled={setAllOtpFilled}
        />
      </Form>
    </RegistrationCard>
  );
}
